export const GET_INSIGHTS_OVERVIEW = 'get-insights-overview';
export const GET_INSIGHTS_TIMESERIES = 'get-insights-timeseries';
export const GET_INSIGHTS_PLATFORMS = 'get-insights-platforms';
export const GET_INSIGHTS_BRAND_FUNNELS = 'get-insights-brand-funnels';
export const GET_INSIGHTS_PROMPT_FUNNELS = 'get-insights-prompt-funnels';
export const GET_INSIGHTS_BRAND_FUNNELS_TIMESERIES = 'get-insights-brand-funnels-timeseries';
